export interface Testimonial {
  name: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    name: "",
    content: "付費使用 Clarymind 一個多月了，開始用的原因，是想透過減少使用社群媒體的時間，來降低它們所帶來的焦慮感。\n\n目前看起來「減少使用時間」滿有效的，我瀏覽各大社群平台的時間大幅縮短。\n\n（使用者公開分享於個人帳號）",
    rating: 5
  },
  {
    name: "",
    content: "不再花好幾小時滑手機後，我變得專注許多。很喜歡這 app 會溫柔的提醒你「真的想打開嗎？」\n\n（翻譯自美國評論）",
    rating: 5
  },
  {
    name: "",
    content: "X（推特）鎖了之後可能一整天都不會打開它\n\n對比開始鎖之前，一週大概少花 16 個小時",
    rating: 5
  },
  {
    name: "",
    content: "幫你找回現實生活的 App\n\n如果你每天忍不住一直滑社群媒體，又總是後悔自己不該這樣浪費時間\n\n那其實不一定是你不夠有自制力，或許是缺了一個好工具，Clarymind 就是一個可以幫助你無痛減少手機使用時間的超棒工具！",
    rating: 5
  },
  {
    name: "",
    content: "不只省下了我的時間，也減少了過往因為無意識滑 Instagram 導致的焦慮。謝謝 Clarymind 🤍\n\n（翻譯自英文評論）",
    rating: 5
  },
  {
    name: "",
    content: "我被診斷出 ADHD，新年新希望是想減少衝動購物和螢幕時間。\n\n我不小心發現這個 app，起初沒想太多，但後來很驚喜發現，它不只很可愛，而且在各種練習與阻擋 app 的設計上，真的很貼心。\n\n（翻譯自美國評論）",
    rating: 5
  },
  {
    name: "",
    content: "Clarymind 藉由延長開啟社群軟體的時間，在等待的時間顯示一些值得反思的問題，有效讓我減少下意識尋求社交刺激的習慣。",
    rating: 5
  },
  {
    name: "",
    content: "真正對我有幫助的是，吸吐後 App 提供的反思小語錄，以及自由調整一天可使用軟體的次數和時長。\n\n跟其他軟體不同的是，Clarymind 自由度高，讓我更願意遵守跟自己約定好的使用狀態。\n\n（使用者公開分享於個人帳號）",
    rating: 5
  },
  {
    name: "",
    content: "螢幕時間 AI 功能真的很讚！把正念「停一下」的概念加進設計，幫助使用者練習覺察到自己正要做什麼\n\n這個機制真的對於戒掉無意識的成癮行為很有幫助！",
    rating: 5
  },
  {
    name: "",
    content: "每次只放行一小段時間真的可以阻止 mindless scrolling，很讚～",
    rating: 5
  },
  {
    name: "",
    content: "用過幾種靜心軟體，正念冥想、關螢幕種樹、番茄鐘，效果都沒有 Clarymind 來得顯著。\n\n（使用者公開分享於個人帳號）",
    rating: 5
  },
  {
    name: "",
    content: "開 Instagram 之前都一定會想是不是真的必要，而且就算有時候忘記原本開的目的，時間到也會上鎖",
    rating: 5
  },
  {
    name: "",
    content: "Clarymind 無疑是現代社會裡，每個人都需要用到的 app。\n\n（翻譯自英文評論）",
    rating: 5
  },
  {
    name: "",
    content: "在經歷強烈的情緒波動時，可以使用 Clarymind 的「呼吸」功能來幫助你平靜心情。\n\n（翻譯自英文評論）",
    rating: 5
  },
  {
    name: "",
    content: "這個 app 提供多樣化的白噪音（動物聲音、雨聲、火焰聲⋯⋯），對於夜班試著在白天入睡時相當有效！\n\n（翻譯自英文評論）",
    rating: 5
  },
  {
    name: "",
    content: "很不錯的冥想音樂，可以隨時快速冥想。App 阻擋功能也很有效！\n\n（翻譯自英文評論）",
    rating: 5
  },
  {
    name: "",
    content: "有中文正念引導十分方便 😍 這個程式的確大大減少了使用社群軟體的時間，並不是很強迫的，而是在你想要打開社群軟體之前，很溫柔的提醒你這是不是你真的需要的？我覺得當下多覺察這一下就可以很好的阻斷自動化打開軟體滑短影音的習慣了 ！！",
    rating: 5
  },
  {
    name: "",
    content: "如果在找一款適合自己使用的專注輔助 app的話 clarymind 個人認為非常適合，還可以協助跳轉到別的應用程式。\n\n而且客服做得非常好！不是那種寫了程式就放著的app。上週發現自己想要的程式沒有辦法跳轉去找客服提意見，結果下週馬上就添加了！而且另外其他的意見也有更新進去。用戶體驗非常好！",
    rating: 5
  },
  {
    name: "",
    content: "人生最重要的就是時間，科技的進步隱含著科技巨頭利用人類注意力去創造更大的財富。\n\n但是人們會越來越不快樂，因為用了太多社群媒體，這個app可以幫助你減少用手機的衝動，幫助你找回平靜的人生。\n\n我是從臉書追蹤到作者，後來發現他出這款 app，我覺得真的很棒，原本是用韓國的app，我認為也不錯，但是這款更完整而且更讓人放鬆！",
    rating: 5
  },
  {
    name: "",
    content: "非常值得下載與訂閱！有效把時間從社交軟體拿回來，還能讓你反思使用社交軟體的必要性，真的設計的太好了！",
    rating: 5
  },
  {
    name: "",
    content: "是個理想型的app 有相見恨晚的感覺，第一次試用感覺非常棒，連背景音樂都非常讓人舒適，與其他app 的等級差異很大，這是一個很值得下載的app",
    rating: 5
  }
];